var Cortona3DSolo = require('solo');
var Tiramisu = Module.Tiramisu;
var app = require('app').app;
var expand = require('lib/util').expand;
var checkConfigureOptions = require('app').checkConfigureOptions;
var usedModules = require('app').usedModules;

var base = require('./base'),
    unmarshalIndexArray = base.unmarshalIndexArray;

var m_currentSheet = {};
var m_sheets = [];

// Cortona3DSolo hooks
Cortona3DSolo.once("app.didAttachDocument", function (doc) {
    if (doc.type == 'ipc') {
        m_sheets = doc.sheets;
        if (app.ipc.interactivity) {
            doc.sheet.drawing = app.ipc.interactivity.getDrawingForIPCView(doc.sheet.id);
        }
        m_currentSheet = expand({}, doc.sheet);
        Cortona3DSolo.once("app.firstFrameDidArrive", function () {
            Tiramisu.ipc.didSelectSheet(m_currentSheet);
        });
        if (usedModules.core.config.ipcHoverColor) {
            app.hoverColor = usedModules.core.config.ipcHoverColor;
        }
        if (usedModules.core.config.ipcSelectionColor) {
            app.selectionColor = usedModules.core.config.ipcSelectionColor;
        }
    }
});

// Tiramisu hooks
expand(Tiramisu, {
    ipc: {
        didSelectSheet: function (sheet) {
            if (app.ipc.interactivity) {
                sheet.drawing = app.ipc.interactivity.getDrawingForIPCView(sheet.id);
            }
            if (app.drawing) {
                app.drawing.load(sheet.drawing)
                    .catch(function () {
                        if (checkConfigureOptions(app.ENABLE_AUTO_SWITCHING_DISPLAY_MODE)) {
                            if (app.ui.isDrawingDisplayMode()) {
                                app.ipc.toggleDrawingDisplayMode();
                            }
                        }
                    });
            }
            m_currentSheet = sheet;
            Cortona3DSolo.dispatch('app.ipc.didSelectSheet', sheet);
        },
        didHoverItem: function (index, items) {
            Cortona3DSolo.dispatch('app.ipc.didHoverItem', index, unmarshalIndexArray(items));
        },
        didSelectItem: function (index, items) {
            Cortona3DSolo.dispatch('app.ipc.didSelectItem', index, unmarshalIndexArray(items));
        },
        didChangeItemVisibility: function (isHidden, items, itemCount) {
            var rows = new Array(itemCount),
                row, i;
            for (i = 0; i < itemCount; ++i) {
                rows[i] = getValue(items + i * 4, 'i32');
            }
            Cortona3DSolo.dispatch('app.ipc.didChangeItemVisibility', isHidden, rows);
        },
        willStartSheetTransitionAnimation: function (sheet) {
            Cortona3DSolo.dispatch('app.ipc.willStartSheetTransitionAnimation', sheet.id);
        },
        didStopSheetTransitionAnimation: function (sheet) {
            Cortona3DSolo.dispatch('app.ipc.didStopSheetTransitionAnimation', sheet.id);
        }
    },
});

var appExports = {
    /**
     * The namespace represents an application interface to manage the interactive parts catalog (IPC).
     * 
     * @namespace
     * @memberof module:solo.app
     * @prop {number} DEFAULT_TRANSITION_STEP_DURATION=1 Default value of transition rate between of IPC sheets.
     */
    ipc: {
        /**
         * Activates IPC sheet by ID.
         * 
         * @param {string} sheetId - IPC sheet ID
         * @param {AnimatedMode} animated
         */
        setCurrentSheet: function (sheetId, animated) {
            Module.ccall('ipc_setCurrentSheet', 'null', ['string', 'number'], [sheetId, app.ui.isDrawingDisplayMode() ? false : animated]);
        },

        /**
         * Toggles 3D IPC item visibility.
         * 
         * @param {number} index - The row number on the current IPC sheet
         */
        toggleItemVisibility: function (index) {
            Module._ipc_toggleItemVisibility(index);
        },

        /**
         * Select 3D IPC item.
         * 
         * @param {number} index - The row number on the current IPC sheet
         * @param {AnimatedMode} [animated=true]
         * @returns {number[]} indices - An array of selected row numbers excluding attaching parts
         */
        selectItem: function (index, animated) {
            return unmarshalIndexArray(Module.ccall('ipc_selectItem', 'number', ['number'], [index, typeof animated === 'undefined' ? true : animated]));
        },

        /**
         * Highlight 3D IPC item.
         * 
         * @param {number} index - The row number on the current IPC sheet
         * @param {AnimatedMode} [animated=true]
         * @returns {number[]} indices - An array of highlighted row numbers excluding attaching parts
         */
        hoverItem: function (index, animated) {
            return unmarshalIndexArray(Module.ccall('ipc_hoverItem', 'null', ['number'], [index, typeof animated === 'undefined' ? true : animated]));
        },

        /**
         * Select only one object (handle) if "objectOnly" = true and if it is possible.
         * Otherwise, all objects from the corresponding row of the DPL table are selected.
         * 
         * @param {Handle} handle - Handle of 3D object 
         * @param {boolean} objectOnly
         * @param {AnimatedMode} [animated=false]
         */
        selectObject: function (handle, objectOnly, animated) {
            Module._ipc_selectObject(handle, objectOnly, animated);
        },

        /**
         * Restore view of the current IPC sheet by default.
         * 
         * @param {AnimatedMode} animated
         */
        resetCurrentSheet: function (animated) {
            if (app.drawing) {
                require('app.drawing').getSVGViewer().reset(animated);
            }
            Module._ipc_resetCurrentSheet(animated);
        },

        /**
         * Get an item with the hotspot name.
         * 
         * @param {string} hotspotName - The name of the hospot
         * @returns {number} The row number on the current IPC sheet
         */
        getItemWithHotspot: function (hotspotName) {
            return Module.ccall('ipc_getItemWithHotspot', 'number', ['string'], arguments);
        },

        /**
         * Returns an object that represents information about the current IPC sheet.
         * 
         * @returns {CatalogCurrentSheetInfo} The object represents IPC sheet information
         * @deprecated since version 1.5.0, use {@link module:solo.app.ipc.currentSheetInfo app.currentSheetInfo} instead
         */
        getCurrentSheet: function () {
            return m_currentSheet;
        },

        /**
         * Toggles display between 2D and 3D views.
         * 
         * @param {boolean} [forceVisible2D] - Forced display of the 2D window
         * @returns {boolean} 
         * @fires "app.ipc.didDrawingDisplayMode"
         */
        toggleDrawingDisplayMode: function (drawingMode) {
            if (!app.drawing) return false;
            drawingMode = (typeof drawingMode === 'undefined') ? !app.drawing.isVisible() : drawingMode;
            app.drawing.show(drawingMode);
            app.ui.showCanvas(!drawingMode);
            Cortona3DSolo.dispatch("app.ipc.didDrawingDisplayMode", drawingMode);
            return drawingMode;
        },

        /**
         * Creates a snapshot of the item.
         * 
         * @param {number} index - The row number on the current IPC sheet
         * @param {number} width - Image width in pixels
         * @param {number} height - Image height in pixels
         * @returns {string|null} Data URL with snapshot image
         * @since 2.1.0
         */
        makeItemSnapshot: function (index, width, height) {
            var data = Module._ipc_makeItemSnapshot(index, width, height);
            if (!data)
                return null;

            width = Module.HEAP32[data >>> 2];
            height = Module.HEAP32[(data >>> 2) + 1];
            var canvas = document.createElement('canvas'),
                context = canvas.getContext('2d'),
                imageData = context.createImageData(width, height);

            imageData.data.set(Module.HEAPU8.subarray(data + 8, data + 8 + width * height * 4));
            canvas.width = width;
            canvas.height = height;
            context.putImageData(imageData, 0, 0);

            Module._free(data);
            return canvas.toDataURL();
        },
        /**
         * Sends a ray from the picked point in the 3D window and returns the IPC object that the ray hit.
         * 
         * @param {number} x - The X coordinate relative to the element `<canvas>`
         * @param {number} y - The Y coordinate relative to the element `<canvas>`
         * @param {number} [options] - Reserved
         * @returns {PickedIPCItemInfo|null} The object with result structure or null
         * @since 2.5.2
         */
        pickItem: function (x, y, options) {
            var sp = stackSave(),
                res = stackAlloc(8),
                pair = Module._ipc_pickItem(x, y, res, 0) ?
                    { 
                        index: HEAP32[res >>> 2], 
                        handle: HEAP32[(res >>> 2) + 1] 
                    } : null;
            stackRestore(sp);
            return pair;
        }
    }
};


/**
 * Gets a description of the current IPC sheet.
 * 
 * @static
 * @member {CatalogCurrentSheetInfo} currentSheetInfo
 * @memberof module:solo.app.ipc
 * @readonly
 * @since 1.5.0
 */

Object.defineProperty(appExports.ipc, 'currentSheetInfo', {
    get: function () {
        return m_currentSheet;
    },
    enumerable: true
});

/**
 * Gets or sets transition rate between of IPC sheets.
 * 
 * @static
 * @member {number} sheetTransitionRate
 * @memberof module:solo.app.ipc
 * @since 1.5.9
 */

Object.defineProperties(appExports.ipc, {
    'sheetTransitionRate': {
        get: function () {
            return 1 / getValue(Module._ipc_getSheetTransitionAnimationDurations() + 4, 'float');
        },
        set: function (value) {
            if (value > 0) Module._ipc_setSheetTransitionAnimationDurations(1 / value, 1 / value);
        },
        enumerable: true
    },
    'DEFAULT_TRANSITION_STEP_DURATION': {
        value: 1,
        enumerable: true
    }
});

/**
 * Checks whether the current sheet has a transition animation.
 * 
 * @static
 * @member {boolean} hasTransitionAnimation
 * @memberof module:solo.app.ipc
 * @readonly
 * @since 2.1.0
 */

/**
 * Gets or sets the transition animation fraction for the current sheet.
 * 
 * @static
 * @member {number} transitionAnimationFraction
 * @memberof module:solo.app.ipc
 * @since 2.1.0
 */

/**
 * Gets or sets the transition animation type.
 * You need to set the transition animation type before switching sheets.
 * 
 * @static
 * @member {TransitionAnimationTypeEnum} transitionAnimationType
 * @memberof module:solo.app.ipc
 * @since 2.1.0
 */

Object.defineProperties(appExports.ipc, {
    'hasTransitionAnimation': {
        get: function () {
            return !!Module._ipc_hasTransitionAnimation();
        },
        enumerable: true
    },
    'transitionAnimationFraction': {
        get: function () {
            return Module._ipc_getTransitionAnimationFraction();
        },
        set: function (value) {
            Module._ipc_setTransitionAnimationFraction(value);
        },
        enumerable: true
    },
    'transitionAnimationType': {
        get: function () {
            return Module._ipc_getTransitionAnimationType();
        },
        set: function (value) {
            Module._ipc_setTransitionAnimationType(value);
        },
        enumerable: true
    },
    'TRANSITION_ANIMATION_TYPE_FROM_TOP_LEVEL_PARENT ': {
        value: 0,
        enumerable: true
    },
    'TRANSITION_ANIMATION_TYPE_FROM_PARENT ': {
        value: 1,
        enumerable: true
    },
    'TRANSITION_ANIMATION_TYPE_LAST_ANIMATION ': {
        value: 2,
        enumerable: true
    }
});

/**
 * Gets or sets the selection mode for only one object.
 * By default, all objects from the current row of the DPL table are selected.
 * 
 * @static
 * @member {boolean} selectOnlyClickedObject
 * @memberof module:solo.app.ipc
 * @since 2.1.0
 */

Object.defineProperty(appExports.ipc, 'selectOnlyClickedObject', {
    get: function () {
        return !!Module._ipc_getSelectOnlyClickedObject();
    },
    set: function (value) {
        Module._ipc_setSelectOnlyClickedObject(value);
    },
    enumerable: true
});

appExports.ipc.dpl = require('app.ipc.dpl');

module.exports = {
    app: appExports
};

/**
 * The hook method is invoked when the IPC sheet is activated.
 * 
 * @memberof module:solo.app.ipc
 * @abstract 
 * @function didSelectSheet
 * @param {CatalogCurrentSheetInfo} sheet - The object represents the IPC sheet information
 * @see The corresponding event {@link event:"app.ipc.didSelectSheet" "app.ipc.didSelectSheet"}
 */
/**
 * @event "app.ipc.didSelectSheet"
 * @see The corresponding hook method {@link module:solo.app.ipc.didSelectSheet app.ipc.didSelectSheet()}
 */

/**
 * The hook method is invoked when the 3D IPC item is hovered.
 * 
 * @memberof module:solo.app.ipc
 * @abstract 
 * @function didHoverItem
 * @param {number} index The row number on the current IPC sheet 
 * @param {number[]} indices An array of highlighted row numbers excluding attaching parts
 * @see The corresponding event {@link event:"app.ipc.didHoverItem" "app.ipc.didHoverItem"}
 */
/**
 * @event "app.ipc.didHoverItem"
 * @see The corresponding hook method {@link module:solo.app.ipc.didHoverItem app.ipc.didHoverItem()}
 */

/**
 * The hook method is invoked when the 3D IPC item is selected.
 * 
 * @memberof module:solo.app.ipc
 * @abstract 
 * @function didSelectItem
 * @param {number} index The row number on the current IPC sheet
 * @param {number[]} indices An array of highlighted row numbers excluding attaching parts
 * @see The corresponding event {@link event:"app.ipc.didSelectItem" "app.ipc.didSelectItem"}
 */
/**
 * @event "app.ipc.didSelectItem"
 * @see The corresponding hook method {@link module:solo.app.ipc.didSelectItem app.ipc.didSelectItem()}
 */

/**
 * The hook method is invoked when the visibility state of the 3D IPC item is toggled.
 * 
 * @memberof module:solo.app.ipc
 * @abstract 
 * @function didChangeItemVisibility
 * @param {boolean} isHidden - 
 * - true - hidden
 * - false - visible
 * @param {number[]} indices - Array of index numbers on the current IPC sheet
 * @see The corresponding event {@link event:"app.ipc.didChangeItemVisibility" "app.ipc.didChangeItemVisibility"}
 */
/**
 * @event "app.ipc.didChangeItemVisibility"
 * @see The corresponding hook method {@link module:solo.app.ipc.didChangeItemVisibility app.ipc.didChangeItemVisibility()}
 */

/**
 * The hook method is invoked when the display mode of the catalog is changed.
 * 
 * @memberof module:solo.app.ipc
 * @abstract 
 * @function didDrawingDisplayMode
 * @param {boolean} drawingMode - 
 * - true - 2D display mode
 * - false - 3D display mode
 * @see The corresponding event {@link event:"app.ipc.didDrawingDisplayMode" "app.ipc.didDrawingDisplayMode"}
 * @since 1.4.0
 */
/**
 * @event "app.ipc.didDrawingDisplayMode"
 * @see The corresponding hook method {@link module:solo.app.ipc.didDrawingDisplayMode app.ipc.didDrawingDisplayMode()}
 */

/**
 * The hook method is invoked when the transition animation to the IPC sheet is started.
 * 
 * @memberof module:solo.app.ipc
 * @abstract 
 * @function willStartSheetTransitionAnimation
 * @param {string} sheetId - IPC sheet ID
 * @see The corresponding event {@link event:"app.ipc.willStartSheetTransitionAnimation" "app.ipc.willStartSheetTransitionAnimation"}
 * @since 1.6.4
 */
/**
 * @event "app.ipc.willStartSheetTransitionAnimation"
 * @see The corresponding hook method {@link module:solo.app.ipc.willStartSheetTransitionAnimation app.ipc.willStartSheetTransitionAnimation()}
 */

/**
 * The hook method is invoked when the transition animation to the IPC sheet is finished.
 * 
 * @memberof module:solo.app.ipc
 * @abstract 
 * @function didStopSheetTransitionAnimation
 * @param {string} sheetId - IPC sheet ID
 * @see The corresponding event {@link event:"app.ipc.didStopSheetTransitionAnimation" "app.ipc.didStopSheetTransitionAnimation"}
 * @since 1.6.4
 */
/**
 * @event "app.ipc.didStopSheetTransitionAnimation"
 * @see The corresponding hook method {@link module:solo.app.ipc.didStopSheetTransitionAnimation app.ipc.didStopSheetTransitionAnimation()}
 */

/**
 * The object represents information about the current IPC sheet, for example:
 * ```
 * {
 *      id: "view_2",
 *      description: "Backplate Assy View",
 *      drawing: "http://.../pump-catalog-2.svg",
 *      dplTableWidth: 69,
 *      dplTable: "<table id=\"dpl-table\" class=\"dpl-table\">...</table>"
 * }
 * ```
 * @prop {string} id - IPC sheet ID. 
 * @prop {string} description - IPC sheet description.
 * @prop {string} drawing - The name of the file for 2D illustration.
 * @prop {number} dplTableWidth - DPL table width.
 * @prop {string} dplTable - The HTML string is a detailed parts list (DPL) in the form of an HTML table.
 * @typedef {object} CatalogCurrentSheetInfo
 * @see {@link module:solo.app.ipc.didSelectSheet app.ipc.didSelectSheet()}
 * @see {@link module:solo.app.ipc.getCurrentSheet app.ipc.getCurrentSheet()}
 */

/**
 * The object visibility code.
 * @prop {number} app.ipc.TRANSITION_ANIMATION_TYPE_FROM_TOP_LEVEL_PARENT=0 The transition animation is built along the chain of parents from the top level. By default.
 * @prop {number} app.ipc.TRANSITION_ANIMATION_TYPE_FROM_PARENT=1 The transition animation is used only from the immediate parent sheet.
 * @prop {number} app.ipc.TRANSITION_ANIMATION_TYPE_LAST_ANIMATION=2 The transition animation is used only for the last animation in the transition to the current sheet.
 * @typedef {number} TransitionAnimationTypeEnum
 * @see {@link module:solo.app.ipc.transitionAnimationType app.ipc.transitionAnimationType}
 */

/**
 * Information about the picked IPC item, for example:
 * ```
 * { 
 *      index: 7,
 *      handle: 1785704
 * }
 * ```
 * @typedef {object} PickedIPCItemInfo
 * @prop {number} index - The row number on the current IPC sheet
 * @prop {Handle} handle - Handle of 3D object 
 * @see {@link module:solo.app.ipc.pickItem app.ipc.pickItem()}
 */

